<template>
  <span class="jom-inlineformula">
    <span class="jom-inlineformula1" ref="formula">
    <component :is="'jo' + item.name" v-for="item in this.data" v-bind:key="item.index" v-bind:data="item.data"></component></span>
  </span>
</template>

<script>
  import jomath from './math.vue'
  import jointablefig from '../fig/intablefig.vue'
  export default {
    components: {
      jomath,
      jointablefig
    },
    props: [
      'data'
    ],
    mounted(){
      let _this = this;
      if (typeof MathJax === "undefined"){
        this.setDisplay();
      }else MathJax.Hub.Queue(["Typeset", MathJax.Hub,_this.$refs.formula],[_this.setDisplay])
    },
    methods:{
      setDisplay(){
        if (this.$refs.formula && $(this.$refs.formula).width()<document.body.clientWidth-40){
          $(this.$refs.formula).css('display','inline');
        }
      }
    }
  }
</script>

<style>
  .jom-inlineformula1{
    max-width: 100%;
    overflow-x: auto;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/formula/inlineformula.vue